import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { getAccount, getAccountSubscription } from '@app/reducers/account/account-service.selectors';
import { AppState } from '@app/reducers/interfaces';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { mgcIconDiamond2CuteRe } from '@sb/mgc-icons/mgcIcon-diamond_2_cute_re.icon';
import { NotificationBadgeComponent } from '@sb/ui/badge';
import { ButtonComponent } from '@sb/ui/button';
import { IconComponent, IconRegistry } from '@sb/ui/icon';
import { SbSidebar } from '@sb/ui/navigation';
import { PopoverComponent, PopoverDirective } from '@sb/ui/popover';
import { PlanType } from '@shiftbase-com/ts-shared/models';
import clsx from 'clsx';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-side-nav-upsell',
  templateUrl: './app-side-nav-upsell.component.html',
  imports: [
    NotificationBadgeComponent,
    IconComponent,
    NgTemplateOutlet,
    TranslatePipe,
    ButtonComponent,
    PopoverComponent,
    PopoverDirective,
  ],
  host: {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '[class]': 'hostClass()',
  },
})
export class AppSideNavUpsellComponent {
  #sidebar = inject(SbSidebar);
  #store = inject(Store<AppState>);
  #router = inject(Router);

  #account = this.#store.selectSignal(getAccount);
  #subscription = this.#store.selectSignal(getAccountSubscription);

  minimized = computed(() => this.#sidebar?.isMinimized() ?? false);
  hostClass = computed(() =>
    clsx(
      'relative block rounded-md border border-solid',
      this.minimized() ? 'border-transparent p-sm' : 'border-default p-md',
    ),
  );

  trialDays = computed(() => this.#account()?.trialDays);
  hasTrial = computed(() => this.#account()?.hasTrial);
  #isConfirmedAccount = computed(() => this.#account()?.continue_subscription);
  hasFreePlan = computed(() => this.#subscription()?.plan.type === PlanType.FREE);

  constructor() {
    inject(IconRegistry).registerIcons([mgcIconDiamond2CuteRe]);
  }

  openPlanWizard(): void {
    if (this.#isConfirmedAccount()) {
      this.#router.navigate(['account', 'billing', { originator: 'btn-header', open: 'plan-wizard' }]);
      return;
    }

    this.#router.navigate(['', { outlets: { modal: ['subscription'] } }]);
  }
}
